<template>
  <div class="mt-10 max-w-6xl mx-auto">
    <ul
      role="list"
      class="grid grid-cols-1 gap-6 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4"
    >
      <li
        class="col-span-1 flex flex-col text-center bg-white rounded-lg shadow divide-y divide-gray-200"
        v-for="(integration, index) of integrations"
        :key="index"
        @click="gotoIntegration(integration)"
      >
        <div class="flex-1 flex flex-col p-8">
          <img
            class="w-32 h-32 flex-shrink-0 mx-auto object-contain"
            src="../../assets/integrations/loox.png"
            alt=""
          />
          <h3 class="mt-6 text-gray-900 text-sm font-medium">
            {{ integration.name }}
          </h3>
          <dl class="mt-1 flex-grow flex flex-col justify-between">
            <dd class="text-gray-500 text-sm">{{ integration.category }}</dd>
          </dl>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      integrations: []
    };
  },
  created() {
    this.$store.dispatch("Integrations/getIntegrations").then(response => {
      this.integrations = response.integrations;
    });
  },
  methods: {
    gotoIntegration(integration) {
      if (integration.slug === "loox") {
        const store = this.$store.getters.getStore;
        if (store.plan === "free" || store.plan === "limited_free") {
          alert("please upgrade to paid plans for integrations");
          this.$router.push({ name: "Plan" });
          return;
        }
        console.log("goto loox page");
        this.$router.push({ name: "LooxHome" });
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
